module.exports = __webpack_public_path__ + "static/media/Diarios-de-um-Piquenique-1.0241b97e.jpg";